function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15636_7073)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_15636_7073)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-0.496094 0.818359H27.4349V17.182H-0.496094V0.818359Z",
  fill: "#DA251D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.8739 12.9951L13.6152 10.8634L10.3784 13.0143L11.5786 9.51145L8.3418 7.34774L12.346 7.31578L13.5898 3.81934L14.8518 7.3062L18.8559 7.30939L15.6373 9.49547L16.8702 12.9983L16.8739 12.9951Z",
  fill: "#FFFF00"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.96875,
  y: 0.5,
  width: 25,
  height: 17,
  rx: 1.5,
  stroke: "#E0E4E8"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15636_7073"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.46875,
  y: 1,
  width: 24,
  height: 16,
  rx: 1,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_15636_7073"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.8276,
  height: 16.3636,
  fill: "white",
  transform: "translate(1.05469 0.818359)"
})));

function SvgVi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVi);
export default __webpack_public_path__ + "static/media/vi.383a4d6e.svg";
export { ForwardRef as ReactComponent };